import React from 'react'

export default function LinearInstallDescription() {
  return (
    <React.Fragment>
      <p>
        Create and link Linear issues from Groove without adding extra fields,
        labels, or side workflows.
      </p>

      <p>With this integration you can:</p>
      <ul>
        <li>Create new issues from conversations</li>
        <li>Link existing issues by exact identifier or URL</li>
        <li>View linked issue state and destination in the sidebar</li>
      </ul>
    </React.Fragment>
  )
}
